// const baseURL = 'https://parking-management-service-804561330.development.catalystserverless.com/server/parking-management-service/';
//const baseURL = 'http://localhost:5000/';
// const baseURL = '/server/parking-management-service/';
// const baseURL = 'http://parking-clip.com/server/parking-management-service/';
const baseURL = "https://visitor-clip.com:4001/";
// const baseURL = 'http://localhost:3000/server/parking-management-service/';
export default baseURL;
